var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vx-card", [
    _c("div", { staticClass: "header-block" }, [
      _c("h4", [_vm._v("Log de acesso a dado pessoal")]),
      _c("p", [
        _vm._v(
          " Responde a pergunta que abre toda investigação de incidente: "
        ),
        _c("strong", [
          _vm._v(
            "quem viu o CPF, o dado bancário ou o motivo médico deste titular, e quando"
          ),
        ]),
        _vm._v(
          " (LGPD, Art. 46 e 48). Registra acesso de operador — o titular lendo o próprio dado não entra aqui, senão a tabela vira ruído. "
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "filters-row" },
      [
        _c(
          "vs-select",
          {
            staticClass: "filter-field",
            attrs: { label: "Categoria" },
            on: { input: _vm.load },
            model: {
              value: _vm.filters.category,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "category", $$v)
              },
              expression: "filters.category",
            },
          },
          [
            _c("vs-select-item", { attrs: { value: "", text: "Todas" } }),
            _vm._l(_vm.categoryLabels, function (label, key) {
              return _c("vs-select-item", {
                key: key,
                attrs: { value: key, text: label },
              })
            }),
          ],
          2
        ),
        _c("vs-input", {
          staticClass: "filter-field",
          attrs: { label: "ID do titular", placeholder: "Ex.: 42" },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.load.apply(null, arguments)
            },
          },
          model: {
            value: _vm.filters.subject_user_id,
            callback: function ($$v) {
              _vm.$set(_vm.filters, "subject_user_id", $$v)
            },
            expression: "filters.subject_user_id",
          },
        }),
        _c("vs-input", {
          staticClass: "filter-field",
          attrs: { label: "ID de quem acessou", placeholder: "Ex.: 7" },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.load.apply(null, arguments)
            },
          },
          model: {
            value: _vm.filters.actor_id,
            callback: function ($$v) {
              _vm.$set(_vm.filters, "actor_id", $$v)
            },
            expression: "filters.actor_id",
          },
        }),
        _c("vs-button", { attrs: { size: "small" }, on: { click: _vm.load } }, [
          _vm._v("Filtrar"),
        ]),
      ],
      1
    ),
    _vm.loading
      ? _c("div", { staticClass: "state-message" }, [_vm._v("Carregando…")])
      : !_vm.rows.length
      ? _c("div", { staticClass: "state-message" }, [
          _vm._v(" Nenhum acesso registrado com estes filtros. "),
        ])
      : _c("table", { staticClass: "privacy-table" }, [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v("Quando")]),
              _c("th", [_vm._v("Quem acessou")]),
              _c("th", [_vm._v("Titular")]),
              _c("th", [_vm._v("Categoria")]),
              _c("th", [_vm._v("Ação")]),
              _c("th", [_vm._v("Rota")]),
            ]),
          ]),
          _c(
            "tbody",
            _vm._l(_vm.rows, function (row) {
              return _c("tr", { key: row.id }, [
                _c("td", [_vm._v(_vm._s(_vm.formatDateTime(row.created_at)))]),
                _c("td", [
                  _c("div", { staticClass: "subject" }, [
                    _c("strong", [
                      _vm._v(_vm._s(row.actor ? row.actor.name : "—")),
                    ]),
                    row.actor_legal_entity_id
                      ? _c("span", [
                          _vm._v("Clube #" + _vm._s(row.actor_legal_entity_id)),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("td", [
                  _c("div", { staticClass: "subject" }, [
                    _c("strong", [
                      _vm._v(_vm._s(row.subject ? row.subject.name : "—")),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(row.subject ? row.subject.email : "")),
                    ]),
                  ]),
                ]),
                _c("td", [
                  _c("span", { staticClass: "pill", class: row.category }, [
                    _vm._v(_vm._s(row.category_label)),
                  ]),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(row.action === "export" ? "Exportação" : "Leitura")
                  ),
                ]),
                _c("td", { staticClass: "route-cell" }, [
                  _vm._v(_vm._s(row.route)),
                ]),
              ])
            }),
            0
          ),
        ]),
    _vm.pagination.last_page > 1
      ? _c(
          "div",
          { staticClass: "pagination-row" },
          [
            _c(
              "vs-button",
              {
                attrs: {
                  size: "small",
                  type: "border",
                  disabled: _vm.page <= 1,
                },
                on: {
                  click: function ($event) {
                    return _vm.go(_vm.page - 1)
                  },
                },
              },
              [_vm._v("Anterior")]
            ),
            _c("span", [
              _vm._v(
                "Página " +
                  _vm._s(_vm.pagination.current_page) +
                  " de " +
                  _vm._s(_vm.pagination.last_page)
              ),
            ]),
            _c(
              "vs-button",
              {
                attrs: {
                  size: "small",
                  type: "border",
                  disabled: _vm.page >= _vm.pagination.last_page,
                },
                on: {
                  click: function ($event) {
                    return _vm.go(_vm.page + 1)
                  },
                },
              },
              [_vm._v("Próxima")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }